import React, { useState } from 'react';

import PropTypes from 'prop-types';

import translations from '../../languages/i18n';

import fieldStyles from '../../styles/fieldStyles';

import { 
  Area,
  AreaChart,
  // Brush,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

export default function CustomAreaChart({ data, areaDataKey}) {

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {     
      return (
        <div style={{backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, paddingTop: 5, paddingBottom: 5, paddingLeft: 10, paddingRight: 10}}>
          <p style={{fontWeight: 'bold'}}>{`${label}`}</p>
          <p>{translations[`_${payload[0].dataKey}`]}: {payload[0].value}</p>  
        </div>
      );
    }  
    return null;
  };

  return (
    <div style={{ width: 1000, height: 300}}>        
      <ResponsiveContainer>
          <AreaChart
            width={500}
            height={300}
            data={data}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='date' />
          <YAxis />
          <Tooltip content={<CustomTooltip />}/>
          <Area type='monotone' dataKey={areaDataKey} stroke='#15afca' fill='#15afca' />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}

// Indica i controla els props que se han de passar al component
CustomAreaChart.propTypes = {
  data: PropTypes.array.isRequired,
  areaDataKey: PropTypes.string.isRequired
};
